export default {
    add_stage: "Mərhələ əlavə edin",
    additional: "Əlavə",
    alternative: "Alternativ",
    amount_completed: "Tamamlanmış məbləğ",
    apply_plan_treatment: "Müalicə planını tətbiq edin",
    apply_to_which_teeth: "Hansı dişlərə müraciət etmək lazımdır",
    apply_treatment_stage_template: "Müalicə addımı şablonunu tətbiq edin",
    are_you_sure_you_want_to_cancel_plan: "Müalicə planını ləğv etmək istədiyinizə əminsiniz?",
    by_stages: "Mərhələlərə görə",
    calls_planning: "Zənglərin planlaşdırılması",
    cancel_plan_treatment: "Müalicə planını ləğv edin",
    changes_in_current_stage_were_not_saved: "Cari addımda edilən dəyişikliklər yadda saxlanmır",
    choose_criterias_for_fill: "Doldurmaq üçün lazım olan meyarları seçin",
    collapse: "Yıxılma",
    comments: "Şərhlər",
    completed_sum: "Tamamlanmış məbləğ",
    complex_doctor: "Kompleks həkim",
    'DD.MM.YYYY': "GG.AA.YYYY",
    deadline2: "Son tarix",
    delete_stage: "Mərhələni silin",
    document_header: "Müalicə planında şapka",
    editing_is_blocked_now_user_is_working: "Redaktə etmək müvəqqəti olaraq mümkün deyil: {user} hazırda işləyir",
    expand: "Genişləndirin",
    grouped: "Qruplaşdırılmış",
    grouped_by_services: "Xidmətlərə görə qruplaşdırılmış",
    grouped_by_teeth: "Dişlərə görə qruplaşdırılmış",
    hide_tooth_formula: "Diş formulunu gizlədin",
    kits_and_materials: "Kitlər və materiallar",
    last_update: "Son dəyişiklik",
    left: "Sol",
    level_description: "Mərhələ təsviri",
    main_complaints: "Əsas şikayətlər",
    not_signed: "İmzalanmamış",
    notification_date: "Bildiriş tarixi",
    plan: "Plan",
    plan_status: "Plan Vəziyyəti",
    plan_treatment_application: "Müalicə planının tətbiqi",
    plan_treatment_status: "Müalicə planının statusu",
    plan_type: "Plan növü",
    planned_sum: "Planlaşdırılmış məbləğ",
    previous_visits: "Keçmiş ziyarətlər",
    quantity: "Kəmiyyət",
    recommended: "Tövsiyə edilən",
    reset_all: "Hamısını sıfırla",
    route_list: "Marşrut vərəqi",
    save_as_plan_stage_template: "Müalicə addımı şablonu kimi yadda saxlayın",
    select_a_doctor_2: "Bir həkim seçin",
    select_all: "Hamısını seçin",
    select_field: "Bir istiqamət seçin",
    select_number: "Nömrə seçin",
    select_plan: "Bir plan seçin",
    select_type: "Növü seçin",
    services_selected: "Xidmətlər seçildi",
    show_tooth_formula: "Diş formulunu göstərin",
    sign_without_upload: "Yükləmədən imzala",
    signed_at: "İmzalanıb",
    stage_deletion_confirm_text: "Mərhələ bərpa imkanı olmadan silinəcək. Yadda saxlanmamış dəyişikliklər itiriləcək.",
    stage_doctor: "Mərhələ həkimi",
    stage_title: "Səhnə adı",
    stages_discount: "Mərhələlərdə endirim",
    total_sum: "Ümumi məbləğ",
    treatment_plan_amount: "Müalicə planının məbləği",
    treatment_plan_doctor: "Müalicə planının həkimi",
    treatment_template_application: "Müalicə şablonunun tətbiqi",
    which_fields_to_fill: "Hansı sahələri doldurmaq lazımdır",
    write_patient_complaints: "Xəstənin şikayətlərini yazın",
    write_stage_description: "Mərhələnin təsvirini yazın"
}
